// extracted by mini-css-extract-plugin
module.exports = {"linkBtn":"Payments_linkBtn__2zes7"};